import { render } from "./TitleAgeBadge.vue?vue&type=template&id=084b2772"
import script from "./TitleAgeBadge.vue?vue&type=script&lang=js"
export * from "./TitleAgeBadge.vue?vue&type=script&lang=js"

import "./TitleAgeBadge.vue?vue&type=style&index=0&id=084b2772&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__